import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import Spin from 'antd/lib/spin';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { selectToken } from '../../../features/auth/ducks';
import { InvestmentList } from '../../../features/investment-management/components';
import {
  selectAllocation,
  fetchAllocationActions,
  selectInvestments,
  selectInvestmentsFilter,
  selectInvestmentsPagination,
  fetchAllocationInvestmentsActions,
  setAllocationInvestmentsFilterAction,
} from '../ducks';
import { apiCallIds } from '../api';
import { AllocationDetail } from '../components';

const mapStateToProps = (state, props) => ({
  allocation: selectAllocation(state),
  investments: selectInvestments(state),
  investmentsFilter: selectInvestmentsFilter(state),
  investmentsPagination: selectInvestmentsPagination(state),
  isLoadingAllocation: selectIsInProgress(state, apiCallIds.FETCH_ALLOCATION),
  isLoadingInvestments: selectIsInProgress(state, apiCallIds.FETCH_ALLOCATION_INVESTMENTS),
  allocationId: props.params.allocationId,
  token: selectToken(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAllocation: fetchAllocationActions.request,
      fetchInvestments: fetchAllocationInvestmentsActions.request,
      setInvestmentsFilter: setAllocationInvestmentsFilterAction,
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class AllocationDetailContainer extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    allocation: PropTypes.object,
    investments: PropTypes.array.isRequired,
    investmentsFilter: PropTypes.object.isRequired,
    investmentsPagination: PropTypes.object.isRequired,
    isLoadingAllocation: PropTypes.bool.isRequired,
    isLoadingInvestments: PropTypes.bool.isRequired,
    allocationId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    token: PropTypes.string.isRequired,
  };

  componentDidMount() {
    const { allocationId, investmentsFilter, actions } = this.props;
    actions.fetchAllocation({ allocationId });
    actions.fetchInvestments({ ...investmentsFilter, allocationId });
  }

  handleInvestmentsTableChange = (pagination, filters, sorter) => {
    this.props.investmentsPagination.current = pagination.current;
    this.props.actions.fetchInvestments({
      ...this.props.investmentsFilter,
      pageNo: pagination.current - 1,
      allocationId: this.props.allocationId,
    });
  };

  onInvestmentsFilterChange = filterKey => filterValue => {
    const { filter, allocationId, actions } = this.props;
    actions.setInvestmentsFilter({
      ...filter,
      [filterKey]: filterValue,
      allocationId,
    });
  };

  onInvestmentsFilterStatusChange = this.onInvestmentsFilterChange('status');

  render() {
    const {
      allocation,
      investments,
      investmentsFilter,
      investmentsPagination,
      isLoadingInvestments,
      isLoadingAllocation,
      token,
      t,
    } = this.props;

    if (!allocation) {
      return (
        <Spin spinning={isLoadingAllocation}>
          <div className="spin-empty-content" />
        </Spin>
      );
    }

    return (
      <Spin spinning={isLoadingAllocation}>
        <h1>{t('Detail investície')}</h1>
        <AllocationDetail allocation={allocation} token={token} />

        <div className="padded">
          <h2>{t('Napárované investície')}</h2>
          <InvestmentList
            investments={investments}
            pagination={investmentsPagination}
            filter={investmentsFilter}
            onTableChange={this.handleInvestmentsTableChange}
            onFilterStatusChange={this.onInvestmentsFilterStatusChange}
            isLoading={isLoadingInvestments}
          />
        </div>
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocation-management/containers/AllocationDetailContainer.js